module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc20-fe9f5e1c93481b26e89c846cc13041e3.jpg";